module.exports = __webpack_public_path__ + "static/media/nortondeluxe.35f909fb.png";